module.exports = __webpack_public_path__ + "static/media/raise.17c4e950.png";